import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HomeStream from '../containers/homeStream';

class App extends Component {

  componentWillMount() {
    this.props.actions.loadCurrentUser();
    this.props.actions.loadLikeTypes();
  }

  render() {
    if (this.props.currentUserLoaded && this.props.likeTypesLoaded) {
      return (
        <div>
          <HomeStream currentUser={this.props.currentUser} likeTypes={this.props.likeTypes} />
        </div>
      );
    } else if (this.props.currentUserLoadingError) {
      return (
        <p>Couldn't load current user ({this.props.currentUserLoadingError})</p>
      );
    } else {
      return (
        <div>
          <p>Loading current user...</p>
        </div>
      );
    }
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired,
  currentUser: PropTypes.object,
  currentUserLoaded: PropTypes.bool.isRequired,
  currentUserLoadingError: PropTypes.string,
  likeTypes: PropTypes.array,
  likeTypesLoaded: PropTypes.bool.isRequired
};

export default App;


// WEBPACK FOOTER //
// ./src/views/app.js